import { FC } from 'react';
import { useLocation, useParams } from 'react-router';
import { Center } from '@chakra-ui/react';

import ErrorCard from 'components/ErrorCard';
import Loader from 'components/Loader';
import * as OfferDetailsLayout from 'layouts/OfferDetailsLayout';
import * as OffersLayout from 'layouts/OffersLayout';

import OfferCard from '../../components/OfferCard';
import * as routes from '../../routes';
import { CollectionDetailsRouteState } from '../../types';
import { getBackButtonUrl } from '../utils';
import useGetToolboxCollection from './hooks/useGetToolboxCollection';

interface RouteParams {
  collectionId: string;
}

const CollectionDetails: FC = () => {
  const { state: routeState } = useLocation<CollectionDetailsRouteState>();
  const { collectionId } = useParams<RouteParams>();
  const { collection, error, loading, refetch } =
    useGetToolboxCollection(collectionId);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Center h="100%">
        <ErrorCard retry={refetch} />
      </Center>
    );
  }

  return (
    <OffersLayout.PageContainer
      trackViewProps={{
        eventProperties: {
          ...routeState,
          collectionTitle: collection?.title,
        },
        pageName: 'ToolboxCollectionDetails Viewed',
        usePrefix: false,
      }}
    >
      <OfferDetailsLayout.BackButton to={getBackButtonUrl(routeState)} />

      <OffersLayout.PageTitle
        description={collection?.description as string}
        title={collection?.title as string}
      />

      {collection?.offers ? (
        <OffersLayout.ListGrid>
          {collection.offers.map((offer) => (
            <OfferCard.Link
              key={offer.toolboxOfferId}
              to={{
                pathname: routes.getOfferPath(offer.toolboxOfferId),
                state: { collectionId, from: 'collection-details' },
              }}
            >
              <OfferCard partner={offer.partner} perkBadge={offer.perkBadge}>
                {offer.title}
              </OfferCard>
            </OfferCard.Link>
          ))}
        </OffersLayout.ListGrid>
      ) : null}
    </OffersLayout.PageContainer>
  );
};

export default CollectionDetails;
